export default function () {
  const widgetName = 'seoBlock';
  const widgetOpts = seoBlockOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customStyle() {
        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).find('.moreButton').removeAttr('target');
          $(this).find('.moreButton').addClass('button');
          $(this).find('.button').removeClass('moreButton');
        })
      }
      customStyle()

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn more'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}